import styled from 'styled-components/native';
import {Dimensions} from 'react-native';
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons';
import theme from '../../../global/styles/theme';

export const Container = styled.SafeAreaView<{appTheme: 'light' | 'dark'}>`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const ImageToken = styled.Image`
  height: 40px;
  width: 40px;
`;

export const Column = styled.View``;

export const Body = styled.View`
  align-items: center;
  margin-top: 20px;
  flex: 1;
  width: 100%;
`;

export const ContainerArea = styled.View<{appTheme: 'light' | 'dark'}>`
  flex: 1;
  background-color: ${({ appTheme}) =>
    theme.colors(appTheme).backgroundColor};
  width: 100%;
`;

export const HeaderItem = styled.TouchableOpacity`
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  align-self: center;
`;

export const Item = styled.View`
  width: ${Dimensions.get('window').width / 1.1};
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  min-height: 50px;
  align-self: center;
`;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const RowItem = styled.View`
  align-items: center;
  flex-direction: row;
  gap: 5px;
`;

export const IconImageMaterialIcons = styled(MaterialIcons)``;
export const IconImageMaterialCommunityIcons = styled(MaterialCommunityIcons)``;

export const BodyItem = styled.View<{appTheme: 'light' | 'dark'}>`
  padding: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  border-width: 0.5px;
  border-color: ${({ appTheme}) => theme.colors(appTheme).gray[800]};
  width: 100%;
  max-width: 100%;
  min-width: 100%;
`;

export const RowInfo = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const CircleImage = styled.View`
  margin-right: 10px;
  background-color: white;
  border-radius: 20px;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.Image`
  height: 30px;
  width: 30px;
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const Welcome = styled.View`
  width: 90%;
  align-self: center;
`;

export const CardCarrousel = styled.View`
  width: ${`${Dimensions.get('window').width / 1.25}px`};
  flex: 1;
  border-radius: 20px;
  margin-left: 10px;
  aspect-ratio: 8 / 3;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: center;
`;

export const BannerImage = styled.Image`
  height: 120px;
  border-radius: 20px;
  width: ${`${Dimensions.get('window').width / 1.25}px`};
  aspect-ratio: 8 / 3;
`;
